import { readUniversalLinkParams } from '../../components/universalLink/searchParams/searchParams';

export function createWorkAreaEncodedSelectionStateFromUrlParams(): string {
  const { datasource, objectId, objectType, savedSearchId, workAreaId } =
    readUniversalLinkParams();

  const itemId = objectId ?? savedSearchId;
  const itemType = savedSearchId ? 'saved-search' : objectType;

  if (!datasource || !workAreaId || !itemId || !itemType) {
    return '';
  }

  const selectionState = `${datasource}/${itemId}/${itemType}/${workAreaId}`;
  const encodedSelectionState = urlSafeBase64Encode(selectionState);
  return encodedSelectionState;
}

export function createDatasourceEncodedSelectionStateFromUrlParams(): string {
  const { datasource, objectId, objectType, savedSearchId } =
    readUniversalLinkParams();

  const itemId = objectId ?? savedSearchId;
  const itemType = savedSearchId ? 'saved-search' : objectType;

  if (!datasource || !itemId || !itemType) {
    return '';
  }

  const selectionState = `${datasource}/${itemId}/${itemType}`;
  const encodedSelectionState = urlSafeBase64Encode(selectionState);
  return encodedSelectionState;
}

function urlSafeBase64Encode(input: string): string {
  const base64Encoded = window.btoa(input);
  const urlSafeEncoded = replaceInvalidUrlCharacters(base64Encoded);
  return urlSafeEncoded;
}

function replaceInvalidUrlCharacters(input: string): string {
  return input.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}
